import { render, staticRenderFns } from "./HFDoctorsList.vue?vue&type=template&id=0d4576d8&scoped=true"
import script from "./HFDoctorsList.vue?vue&type=script&lang=js"
export * from "./HFDoctorsList.vue?vue&type=script&lang=js"
import style0 from "./HFDoctorsList.vue?vue&type=style&index=0&id=0d4576d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4576d8",
  null
  
)

export default component.exports